module.exports = __webpack_public_path__ + "img/Software.6b83bb1.webp";